import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueCookies from 'vue-cookies'
import { routes } from './routes'

// This is all you need to do to enable routing
Vue.use(VueRouter);

// Load up the cookie module
Vue.use(VueCookies);

// Register routes here
const router = new VueRouter({ 
  base: "/CannabisCalculatorDev",
  mode: 'history',
  routes, // if key/value is the same, use ES6 syntax
});

new Vue({
  el: '#app',
  router, // if key/value is the same, use ES6 syntax
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js